import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { useLocalStorage } from "../../../../hooks";
import { userState } from "../../../../redux/reducers/userReducer";

import moment from "moment";
import { TwButton, TwRadialProgress } from "../../../../components/tailwind";
import { useToast } from "../../../../provider/ToastProvider";
import { loadingState, setGlobalLoading } from "../../../../redux/reducers/loadingReducer";
import axiosInstance from "../../../../utils/axiosInstance";
import { getUrlForBookings, getUrlForUsers } from "../../../../utils/confighelpers";
import { statusColors } from "../../../../utils/constants";
import { PencilIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
const pricingType = {
    month: 'Monthly',
    year: 'Annually',
}
export default function MyBilling(props) {
    const { t, i18n } = useTranslation();
    const { addToast, addSuccessToast, addErrorToast } = useToast();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const loadingReduxState = useSelector(loadingState);
    const userReduxState = useSelector(userState);
    const [userToken] = useLocalStorage("userToken");
    const [loading, setLoading] = React.useState({ loadingSubscriptionList: false, loadingSubscription: false, loadingInvoice: false });
    const [customerInvoiceList, setCustomerInvoiceList] = React.useState([]);
    const [customerSubscriptionList, setCustomerSubscriptionList] = React.useState([]);
    const [subscriptionPlan, setSubscriptionPlan] = React.useState([]);
    const [currentSubscriptionDetail, setCurrentSubscriptionDetail] = React.useState({
        // price: "99.9",
        // billingType: "month",
    });

    const getStripeCustomerInvoices = async () => {
        // dispatch(setGlobalLoading(true));
        // setSubscriptionPlan([])
        const requestConfig = {
            method: "post",
            url: `${getUrlForBookings()}payments/getStripeCustomerInvoices`,
            data: {
                businessType: userReduxState.businessType
                // "limit":1
            },
        };
        setLoading((prevValues) => ({
            ...prevValues,
            loadingInvoice: customerInvoiceList.length > 0 ? false : true,
        }));
        const response = await axiosInstance(requestConfig);
        setLoading((prevValues) => ({
            ...prevValues,
            loadingInvoice: false,
        }));
        if (response.status === 200) {
            setCustomerInvoiceList([])
            if (response.data.statusCode === 403) {
            } else if (response.data.statusCode === 200) {
                if (response.data.data && response.data.data.invoicesList) {
                    let invoicesList = response.data.data.invoicesList
                    setCustomerInvoiceList(invoicesList)
                }
            }
        }
        dispatch(setGlobalLoading(false));
    };

    const getStripeCustomerSubscriptions = async () => {
        // dispatch(setGlobalLoading(true));
        // setSubscriptionPlan([])
        const requestConfig = {
            method: "post",
            url: `${getUrlForBookings()}payments/getStripeCustomerSubscriptions`,
            data: {
                // businessType: userReduxState.businessType
                // "limit":1
            },
        };
        setLoading((prevValues) => ({
            ...prevValues,
            loadingSubscriptionList: customerInvoiceList.length > 0 ? false : true,
        }));
        const response = await axiosInstance(requestConfig);
        setLoading((prevValues) => ({
            ...prevValues,
            loadingSubscriptionList: false,
        }));
        if (response.status === 200) {
            setCustomerSubscriptionList([])
            if (response.data.statusCode === 403) {
            } else if (response.data.statusCode === 200) {
                if (response.data.data && response.data.data.subscriptionList) {
                    let subscriptionList = response.data.data.subscriptionList
                    setCustomerSubscriptionList(subscriptionList)
                }
            }
        }
        dispatch(setGlobalLoading(false));
    };

    const getSubscriptionPlan = async () => {
        // dispatch(setGlobalLoading(true));
        // setSubscriptionPlan([])
        const requestConfig = {
            method: "get",
            url: `${getUrlForUsers()}getSubscriptionPlans?listFor=${userReduxState.businessType}`,
        };
        setLoading((prevValues) => ({
            ...prevValues,
            loadingSubscription: true,
            loadingInvoice: true,
        }));
        const response = await axiosInstance(requestConfig);
        setLoading((prevValues) => ({
            ...prevValues,
            loadingSubscription: false,
        }));
        if (response.status === 200) {
            if (response.data.statusCode === 403) {
            } else if (response.data.statusCode === 200) {
                if (response.data.data) {
                    setCurrentSubscriptionDetail({})
                    let subscriptionPlanList = response.data.data
                    setSubscriptionPlan(subscriptionPlanList)
                    let mySubscriptionDetails = userReduxState?.userData?.mySubscriptionDetails ?? {}
                    let moduleName = `module_${userReduxState.businessType}`
                    let businessSubscriptionDetails = mySubscriptionDetails[moduleName]

                    if (businessSubscriptionDetails && businessSubscriptionDetails.primarySubscription) {
                        let primarySubscription = businessSubscriptionDetails.primarySubscription
                        let findedCurrentSubscriptionDetail = subscriptionPlanList.find((d) => {
                            if (userReduxState.businessType === "event") {
                                return d.isActive === true && d._id === primarySubscription.id
                            }
                            return d.isActive === true && d.stripeSubscriptionDetails.stripeSubscriptionPriceId === primarySubscription.stripeSubscriptionPlanId
                        })
                        setCurrentSubscriptionDetail(findedCurrentSubscriptionDetail)
                    }
                }
            }
        }
        dispatch(setGlobalLoading(false));
    };

    const getAvailableUserAccess = async (callback = () => { }) => {
        if (userReduxState.businessType) {
            const config = {
                method: "get",
                url: `${getUrlForUsers()}getAvailableUserAccess/${userReduxState.businessType}`,
            };
            const request = await axiosInstance(config);
            if (request.data.statusCode === 200) {
                const responseDetails = request.data.data;
                // setAvailableUserAccess(responseDetails)
                callback(responseDetails)
                if (responseDetails.subscriptionDetails.primarySubscription.allowbusinessAccess === false) {
                    // setOpenSubscriptionWarningDialog(responseDetails.subscriptionDetails.primarySubscription.allowbusinessAccess)
                }
            }
        }
    }

    function getUsedSubscriptionPercentage(startTimestamp, endTimestamp) {
        const now = Math.floor(Date.now() / 1000); // current time in seconds

        if (now < startTimestamp) return 0;
        if (now >= endTimestamp) return 100;

        const totalDuration = endTimestamp - startTimestamp;
        const elapsed = now - startTimestamp;

        return Math.round((elapsed / totalDuration) * 100);
    }


    React.useEffect(() => {
        if (userReduxState.businessType !== "") {
            (async () => {
                setSubscriptionPlan([])
                // await getAvailableUserAccess()
                await getSubscriptionPlan();
                await getStripeCustomerSubscriptions();
                await getStripeCustomerInvoices();

            })();
        }
    }, [userReduxState.businessType]);

    return (
        <div className={"flex flex-col md:p-3"}>
            <div className="divide-y">
                <div className="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 px-4 py-16 md:px-6 md:grid-cols-3 lg:px-8">
                    <div>
                        <h2 className="text-base/7 font-semibold">{t("account.subscriptionInformationTitle")}</h2>
                        <p className="mt-1 text-sm/6 text-gray-400">{t("account.subscriptionInformationSubTitle")}</p>
                    </div>
                    <div className={"flex flex-col gap-4 md:col-span-2"}>
                        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                            <div className="inline-block min-w-full py-2 align-middle sm:px-1">
                                <div className="overflow-hidden shadow ring-1 ring-black/5 sm:rounded-lg">
                                    <table className="min-w-full divide-y divide-gray-300">
                                        <thead className="bg-gray-50">
                                            <tr>
                                                <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                                    {t("account.subscriptionTableProduct")}
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">

                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                    {t("account.subscriptionTableFrequency")}
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                    {t("account.subscriptionTableNextinvoice")}
                                                </th>
                                                <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                                                    <span className="sr-only">{t("account.tableActionHead")}</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-200 bg-white">
                                            {loading.loadingSubscriptionList && loading.loadingSubscriptionList === true ? (
                                                <tr>
                                                    <td colSpan={5} className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center">
                                                        {t("inputFieldsTitle.loading")}
                                                    </td>
                                                </tr>
                                            ) : (customerSubscriptionList.length > 0 ? customerSubscriptionList.map((subscription) => (
                                                <tr key={subscription.number}>
                                                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 flex gap-2 items-center">
                                                        <TwRadialProgress variant="standard" className="size-5" progress={getUsedSubscriptionPercentage(subscription.items.data[0].current_period_start, subscription.items.data[0].current_period_end)} />{subscription?.product_detail?.name || ""}
                                                    </td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 capitalize">
                                                        <div className="flex gap-2 justify-end items-center">
                                                            <div
                                                                className={`p-1 px-2 text-xs rounded-full`}
                                                                style={{ ...(subscription.status ? statusColors[subscription.status.toString().toLowerCase()] : statusColors["false"]) }}
                                                            >
                                                                {subscription.status}
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">Billing {pricingType[subscription.plan.interval]}</td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{moment.unix(subscription.items.data[0].current_period_end).format('DD-MMM')} for €{(subscription.plan.amount / 100)}</td>
                                                    <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                                        {/* <PencilIcon
                                                            className="size-4"
                                                            onClick={() => {
                                                                navigate("/businessprofilesetup/subscription/upgrade", {
                                                                    state: {
                                                                        from: "full",
                                                                        origin: "mybilling",
                                                                    },
                                                                    replace: true
                                                                });
                                                            }}
                                                        /> */}
                                                    </td>
                                                </tr>
                                            )) : (
                                                <tr>
                                                    <td colSpan={5} className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center">
                                                        {t("account.noSubscriptionFound")}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        {loading.loadingSubscription === true && loading.loadingSubscriptionList === true && currentSubscriptionDetail._id == undefined && (<div className={"flex flex-row items-center gap-2"}>
                            <TwButton
                                variant={"secondary-outline"}
                                className="w-full sm:w-auto"
                                onClick={() => {
                                    navigate("/businessprofilesetup/subscription", {
                                        state: {
                                            from: "list",
                                            origin: "paymentprofile",
                                        },
                                        replace: true
                                    });
                                }}
                                disabled={(loadingReduxState.actionLoading !== undefined && loadingReduxState.actionLoading === true)}
                            >
                                {t("account.tryForFree")}
                            </TwButton>
                        </div>)}
                    </div>

                    {false && (loading.loadingInvoice && loading.loadingInvoice === true ? (
                        <div className="flex flex-col gap-4 md:col-span-2 sm:w-full md:max-w-lg">
                            {t("inputFieldsTitle.loading")}
                        </div>
                    ) : (<div className={"flex flex-col gap-4 md:col-span-2 sm:w-full md:max-w-lg"}>
                        {currentSubscriptionDetail._id ? (<div className={"z-10 bg-white ring-1 ring-gray-900/10 max-w-lg rounded-2xl p-6"}>
                            <h2
                                className={`text-gray-900 text-lg font-semibold`}
                            >
                                {currentSubscriptionDetail.title}
                            </h2>
                            <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between lg:flex-col lg:items-stretch">
                                <div className="mt-2 flex items-center gap-x-4">
                                    <p
                                        className={`text-gray-900 text-4xl font-semibold tracking-tight`}
                                    >
                                        {parseFloat(currentSubscriptionDetail.price).toFixed(2)}
                                    </p>
                                    <div className="text-sm">
                                        <p className={'text-gray-900'}>EUR</p>
                                        <p
                                            className={'text-gray-500'}
                                        >{`Billed ${pricingType[currentSubscriptionDetail.billingType]}`}</p>
                                    </div>
                                </div>
                                {currentSubscriptionDetail.billingType === "year" && (<div className="text-sm">
                                    <p
                                        className={'text-gray-500'}
                                    >
                                        {null}
                                        {`You Saved ${parseFloat(((subscriptionPlan.filter((d) => d.isActive === true && d.billingType === "month")[0]?.price ?? 0) * 12) - currentSubscriptionDetail.price).toFixed(2)}`}
                                    </p>
                                </div>)}

                            </div>
                        </div>) : (<div className={"z-10 bg-white ring-1 ring-gray-900/10 max-w-lg rounded-2xl p-6"}>
                            <h2
                                className={`text-gray-900 text-base font-semibold`}
                            >
                                {t("mySubscription.currentSubscription")}
                            </h2>
                            <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between lg:flex-col lg:items-stretch">
                                <div className="mt-2 flex items-center gap-x-4">
                                    <p
                                        className={`text-gray-900 text-3xl font-semibold tracking-tight`}
                                    >
                                        {t("mySubscription.freeTrialDetail")}
                                    </p>
                                </div>
                            </div>
                        </div>)}
                        {userReduxState.businessType !== "event" ? (currentSubscriptionDetail._id ? (<div className={"flex flex-row items-center gap-2"}>
                            <TwButton
                                variant={"secondary-outline"}
                                className="w-full sm:w-auto"
                                onClick={() => {
                                    navigate("/businessprofilesetup/subscription/upgrade", {
                                        state: {
                                            from: "full",
                                            origin: "mybilling",
                                        },
                                        replace: true
                                    });
                                }}
                                disabled={(loadingReduxState.actionLoading !== undefined && loadingReduxState.actionLoading === true)}
                            >
                                {t("mySubscription.upgradeSubscription")}
                            </TwButton>
                        </div>) : (<div className={"flex flex-row items-center gap-2"}>
                            <TwButton
                                variant={"secondary-outline"}
                                className="w-full sm:w-auto"
                                onClick={() => {
                                    navigate("/businessprofilesetup/subscription", {
                                        state: {
                                            from: "list",
                                            origin: "paymentprofile",
                                        },
                                        replace: true
                                    });
                                }}
                                disabled={(loadingReduxState.actionLoading !== undefined && loadingReduxState.actionLoading === true)}
                            >
                                {t("account.tryForFree")}
                            </TwButton>
                        </div>)) : null}
                    </div>))}
                </div>
                <div className="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 px-4 py-16 sm:px-6 md:grid-cols-3 lg:px-8">
                    <div>
                        <h2 className="text-base/7 font-semibold">{t("billing.invoice")}</h2>
                        <p className="mt-1 text-sm/6 text-gray-400">{t("billing.invoiceSubTitle")}</p>
                    </div>
                    <div className={"flex flex-col gap-4 md:col-span-2"}>
                        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                            <div className="inline-block min-w-full py-2 align-middle sm:px-1">
                                <div className="overflow-hidden shadow ring-1 ring-black/5 sm:rounded-lg">
                                    <table className="min-w-full divide-y divide-gray-300">
                                        <thead className="bg-gray-50">
                                            <tr>
                                                <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                                    {t("billing.invoiceTableHead")}
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                    {t("billing.amountTableHead")}
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                    {t("account.subscriptionTableFrequency")}
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                    {t("billing.invoicePeriodTableHead")}
                                                </th>
                                                <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                                                    <span className="sr-only">{t("billing.detailedReportTableHead")}</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-200 bg-white">
                                            {loading.loadingInvoice && loading.loadingInvoice === true ? (
                                                <tr>
                                                    <td colSpan={5} className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center">
                                                        {t("inputFieldsTitle.loading")}
                                                    </td>
                                                </tr>
                                            ) : (customerInvoiceList.length > 0 ? customerInvoiceList.map((invoice) => (
                                                <tr key={invoice.number}>
                                                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                                        {invoice.number}
                                                    </td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">€{(invoice.amount_paid / 100)}</td>
                                                    {/* <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{pricingType[invoice.lines.data[0].plan.interval]}</td> */}
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{pricingType[invoice.lines.data[0].pricing.price_details.recurring.interval]}</td>
                                                    {/* <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{moment.unix(invoice.lines.data[0].period.start).format('DD-MM-YYYY hh:mm A') + " to " + moment.unix(invoice.lines.data[0].period.end).format('DD-MM-YYYY hh:mm A')}</td> */}
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{moment.unix(invoice.lines.data[0].period.start).format('DD-MM-YY') + " - " + moment.unix(invoice.lines.data[0].period.end).format('DD-MM-YY')}</td>
                                                    <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                                        {invoice.invoice_pdf && invoice.invoice_pdf != null && (<a href={invoice.invoice_pdf} rel="noreferrer" target="_blank" className="inline-flex items-center justify-center rounded-xl px-4 py-1.5 text-sm text-center font-semibold shadow-xs text-white bg-primary disabled:bg-gray-300 hover:bg-light-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary">
                                                            {t("billing.downloadPDFBtn")}<span className="sr-only">, {invoice.number}</span>
                                                        </a>)}
                                                    </td>
                                                </tr>
                                            )) : (
                                                <tr>
                                                    <td colSpan={5} className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center">
                                                        {t("billing.noInvoiceFoundMsg")}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
